import marketingParagraphFragmentRawString from '../MarketingParagraphFragment.graphql'

export const marketingParagraphFragmentString =
  marketingParagraphFragmentRawString

export type MarketingParagraphFragment = {
  __typename: 'MarketingParagraph'
  createdAt: string
  updatedAt: string
  id: string
  title: string
  content: string
}

export const isMarketingParagraphFragment = (
  fragment: any,
): fragment is MarketingParagraphFragment =>
  fragment &&
  fragment.__typename === 'MarketingParagraph' &&
  typeof fragment.createdAt === 'string' &&
  typeof fragment.updatedAt === 'string' &&
  typeof fragment.id === 'string' &&
  typeof fragment.title === 'string' &&
  typeof fragment.content === 'string'
